import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceFilter'
})
export class PriceFilterPipe implements PipeTransform {
  transform(array: any, lowPrice: number, highPrice: number, category: string): any {
    if (!array || (lowPrice === null && highPrice === null)) {
      return array;  // No hay precio para filtrar, devuelve el array sin cambios.
    }

    switch(category) {
      case '1':
        // Filtramos los hoteles según el precio mínimo y máximo de las habitaciones
        return array.filter((hotel: any) => {
          // Filtrar habitaciones dentro del rango de precios
          const validRooms = hotel.additionalInfo.rooms.filter((room: any) =>
            room.room.optionNightsNetTotalProf >= lowPrice && room.room.optionNightsNetTotalProf <= highPrice
          );

          // Si existen habitaciones válidas dentro del rango, lo incluimos en el resultado
          return validRooms.length > 0;
        });
      case '6':
         // Filtramos los hoteles según el precio mínimo y máximo de las habitaciones
        return array.filter((experience: any) => {
          // Filtrar habitaciones dentro del rango de precios
          const validExperience = experience.additionalInfo.tours.options.filter((experience: any) =>
            experience?.totalPrice >= lowPrice && experience?.totalPrice <= highPrice
          );

          // Si existen habitaciones válidas dentro del rango, lo incluimos en el resultado
          return validExperience.length > 0;
        });
      case '8':
         // Filtramos los hoteles según el precio mínimo y máximo de las habitaciones
        return array.filter((transfer: any) => {
          // Filtrar habitaciones dentro del rango de precios
          const validRooms = transfer.vehicles.filter((vehicle: any) =>
            vehicle?.totalPriceProf >= lowPrice && vehicle?.totalPriceProf <= highPrice
          );

          // Si existen habitaciones válidas dentro del rango, lo incluimos en el resultado
          return validRooms.length > 0;
        });
    }

  }
}
